"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const viewer_1 = require("../../components/viewer/viewer");
const styles = require('./embed.css');
exports.SceneJSX = (store) => {
    return React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(viewer_1.Player, null));
};
